import { render, staticRenderFns } from "./LatestNotifications.vue?vue&type=template&id=d2dbb92c&scoped=true"
import script from "./LatestNotifications.vue?vue&type=script&lang=js"
export * from "./LatestNotifications.vue?vue&type=script&lang=js"
import style0 from "./LatestNotifications.vue?vue&type=style&index=0&id=d2dbb92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dbb92c",
  null
  
)

export default component.exports